import * as ActionTypes from './types.action';

export const getPbbBankDetails = bankId => ({
  type: ActionTypes.GET_PBB_BANK_DETAILS_REQUESTED,
  bankId,
});
